var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForgotPasswordIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12658",
    "data-name": "Grupo 12658",
    transform: "translate(-78 -153)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_58",
    "data-name": "Elipse 58",
    cx: 110,
    cy: 110,
    r: 110,
    transform: "translate(78 153)",
    fill: "#ddd",
    opacity: 0.143
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12611",
    "data-name": "Grupo 12611",
    transform: "translate(141.116 201.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12610",
    "data-name": "Grupo 12610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12608",
    "data-name": "Grupo 12608",
    transform: "translate(13.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10094",
    "data-name": "Caminho 10094",
    d: "M464.647,348.385h-9.01V318.592a23.582,23.582,0,1,0-47.165,0v29.792h-9.01V318.592a32.592,32.592,0,1,1,65.184,0Z",
    transform: "translate(-399.463 -286)",
    fill: "#72716f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12609",
    "data-name": "Grupo 12609",
    transform: "translate(0 48.247)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2789",
    "data-name": "Ret\\xE2ngulo 2789",
    width: 92.768,
    height: 62.723,
    rx: 17.315,
    fill: "#f2cb30"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10096",
    "data-name": "Caminho 10096",
    d: "M538.337,603.418a7.666,7.666,0,1,0-12.225,6.153l-2.44,17.335h14l-2.44-17.335A7.647,7.647,0,0,0,538.337,603.418Z",
    transform: "translate(-343.171 -331.892)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPasswordIcon);
export default __webpack_public_path__ + "static/media/forgot_password_icon.d6df465ce40dc52be344226dae3e0d38.svg";
export { ForwardRef as ReactComponent };